export type CreateDeploymentRequestComponentNameResponse = {
  warningMessage: string[];
};
